/**
 * CR-8697: the one place that reads the customer's Delivery Metric Mode
 * (Admin Setup › Performance). Every OTIF / OTD gate asks these two helpers,
 * so a mode added later cannot leave a `mode !== 'otd_only'` check showing a
 * metric the admin switched off — which is how "Neither" would otherwise leak.
 *
 * A payload without the field (older responses, or one still loading) shows
 * both metrics, as the dashboard always has.
 *
 * @example
 * const showOTIF = showsOtif(data.delivery_metric_mode)
 */
import type { DeliveryMetricMode } from '../../lib/api'

/**
 * Whether On-Time In-Full is calculated and shown.
 *
 * @param mode - the customer's `delivery_metric_mode`; null / undefined means both
 * @returns true for 'both' and 'otif_only' (and an absent mode)
 */
export function showsOtif(mode: DeliveryMetricMode | null | undefined): boolean {
  return mode == null || mode === 'both' || mode === 'otif_only'
}

/**
 * Whether On-Time Delivery is calculated and shown.
 *
 * @param mode - the customer's `delivery_metric_mode`; null / undefined means both
 * @returns true for 'both' and 'otd_only' (and an absent mode)
 */
export function showsOtd(mode: DeliveryMetricMode | null | undefined): boolean {
  return mode == null || mode === 'both' || mode === 'otd_only'
}
